module.exports = __webpack_public_path__ + "img/airplane-dark.53358a4a.svg";